enum TypeTransfert {
  PI = "PI",
  PPI = "PPI",
}

export default TypeTransfert;
